import axios from 'axios'
import React,{useState,useEffect} from 'react'
import { HistoricalChart } from '../config/api'
import { CryptoState } from '../CryptoContext';
import { useParams } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/styles';
import { CircularProgress, createTheme } from '@material-ui/core';
// import { makeStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
const darkTheme = createTheme({
  palette: {
    primary:{
      main: '#fff'
    },
    type: 'dark',
  },
});

const useStyles=makeStyles({
  container:{
     display:'flex',
     width:'75%',
     justifyContent:'center',
     alignItems:'center',
     marginTop:'25px',
     padding:'40px',
     
  }
 })
const Coininfo = () => {
  

  const classes=useStyles()
  const [historicaldata, sethistoricaldata] = useState();
  const [days, setdays] = useState(1);
  const {currency}=CryptoState();
  const {id}= useParams();

  const getcoins= async()=>{
    const {data}=await axios(HistoricalChart(id,days,currency))
    sethistoricaldata(data.prices)
  }

  // eslint-disable-next-line 
useEffect(() => {
  getcoins()
}, [currency]);

console.log(historicaldata)

 
  return (
      <ThemeProvider theme={darkTheme}  >
      <div className={classes.container} >
       {!historicaldata?(<CircularProgress style={{color:'gold'}} size={250} thickness={1}  />):(
        <>
        <Line 
          data={{labels: historicaldata.map((coin)=>{
             let date= new Date(coin[0])
             let time= date.getHours()>12
             ?`${date.getHours()-12}:${date.getMinutes()}PM`
             :`${date.getHours()}:${date.getMinutes()}AM`;

             return days===1 ? time :date.toLocaleDateString()
          }),
          datasets:[
            {data: historicaldata.map((coin)=> coin[1]),
             label: `price (past ${days}days in ${currency})`,borderColor:'#EEBC1D'
            }
          ]        
        } }
        options={
          {
            elements:{
              point:{
                radius:1
              },
            }
          }
        }
        />  
        </>
       )}

      </div>
       </ThemeProvider>
  )
}

export default Coininfo